import * as React from 'react';

const Camera24 = ({ title, titleId, ...props }) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", width: 24, height: 24, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("g", { fill: "none", fillRule: "evenodd" }, /* @__PURE__ */ React.createElement("path", { d: "M0 0h24v24H0z" }), /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M12 7.506a5 5 0 1 0 0 10 5 5 0 0 0 0-10m0 1.5c1.93 0 3.5 1.57 3.5 3.5s-1.57 3.5-3.5 3.5-3.5-1.57-3.5-3.5 1.57-3.5 3.5-3.5M15 3l-6 .012-2 1.997-4.497-.007H2.5A1.5 1.5 0 0 0 1 6.501v12.941c0 .827.668 1.496 1.495 1.499l19 .059h.005a1.5 1.5 0 0 0 1.5-1.502l-.021-13a1.5 1.5 0 0 0-1.5-1.496h-.003L17 5.009 15 3zm-.622 1.501 1.559 1.566.441.443.624-.001 4.477-.009.021 13-19-.058V6.502l4.498.007.622.001.44-.44 1.562-1.559 4.756-.01z"
  }
)));
Camera24.Size = 24;
Camera24.Title = "Camera";

export { Camera24 as default };
